<div class="card bg-white rounded p-2">
  <h3 class="card-title mb-3">
    {{ 'AdministrationService::Financial' | abpLocalization }}
  </h3>
  <ng-container *ngIf="asset.assetType === AssetType.OWNED; else hiredAssets">
    <app-owned-assets [data]="ownedData" (viewClick)="onView($event)"></app-owned-assets>
  </ng-container>
  <ng-template #hiredAssets>
    <app-hired-assets [data]="hiredData" (viewClick)="onView($event)"></app-hired-assets>
  </ng-template>

  <div class="custom-table" *ngIf="consumptions?.length">
    <ngb-accordion #accAddress="ngbAccordion">
      <ngb-panel>
        <ng-template ngbPanelTitle>
          <div class="flex w-100 justify-between me-2">
            <label class="text-base font-medium text-black-base">
              {{ 'RegisterService::Consumed' | abpLocalization }}
            </label>
            <label>{{ getTotalCount() | number : '1.2-2' | currency : 'EUR' }}</label>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <ngx-datatable [rows]="consumptions" default>
            <ngx-datatable-column
              [sortable]="false"
              name="{{ 'RegisterService::Category' | abpLocalization }}"
              [width]="120"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="table-column-text">
                  {{ row.consumableName }}
                </span>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="{{ 'RegisterService::Quantity' | abpLocalization }}"
              [sortable]="false"
              [width]="80"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.count }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              [sortable]="false"
              name="{{ 'ServicingService::Permission:Inspections' | abpLocalization }}"
              [width]="100"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="table-column-text">
                  {{ row.event }}
                </span>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="{{ 'RegisterService::Date' | abpLocalization }}"
              [width]="110"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.date | date }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              [sortable]="false"
              name="{{ 'ServicingService::Cost' | abpLocalization }}"
              [width]="70"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.cost * row.count | number : '1.2-2' }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              [sortable]="false"
              [width]="100"
              name="{{ 'ServicingService::Operator' | abpLocalization }}"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="table-column-text">
                  {{ row.operatorName }}
                </span>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
  <ngb-accordion #accAddress="ngbAccordion">
    <ngb-panel>
      <ng-template ngbPanelTitle>
        <div class="flex w-100 justify-between me-2">
          <label class="text-base font-medium text-black-base">
            {{ 'AdministrationService::FuelBurn' | abpLocalization }}
          </label>
          <label>{{ asset?.fuelBurn ?? 0.0 }} Litres</label>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <app-event-table
          [data]="data.inspectionDetails"
          (viewClick)="viewClick.emit($event)"
        ></app-event-table>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
